import React from 'react'
import './App.css'
import 'semantic-ui-css/semantic.min.css'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'

import MoU_2 from './views/mou-2'
import Register from './views/form'
import Attendees from './views/attendee'
import Navbar from "./components/navbar";
import MoU_1 from './views/mou-1'

function App () {

  return (

    <Router className='App'>
      <div className='App'>
        <div className = "nav">
            <Navbar/> 
        </div>

          <Switch>
            <Route exact path='/' component={MoU_2} />
            <Route exact path='/register' component={Register} />
            <Route exact path='/attendees' component={Attendees} />
            <Route exact path='/mou-1' component={MoU_1} />
          </Switch>  

      </div>
      
    </Router>
  )
}

export default App